import {useState, useEffect, useLayoutEffect} from 'react'
import './Sentence.css'
import styled from 'styled-components'
import Button from '../Shared/Button'
import {meSplitter} from '../Shared/meGlobal'
import TreeView from "../meTree/TreeView"
import {ToNotify, Etat} from 'fast_inon'
import {DefaultControl, toTime} from '../Shared/ViewControl'
import jsPdf from 'jspdf'
import html2canvas from 'html2canvas'
import Api,{Read, Cookie} from '../Shared/Api'
import {base} from '../Config/app';

const Sentences = ({props}) => {
    const path = 'https://moshaf.akademy.ma/waqafaat/'
    const [message, Message] = useState('')
    const [number, Number] = useState(-1)
    const [section, Section] = useState({Id:0, SooraId:0, Soora:'', Aaya:'', Hizb:'', Tomon:'', Wajh:'', Items:[]})
    const [now, Now] = useState(new Date())
    const [loaded, Load] = useState(false)
    const [play, Play] = useState(false)
    const [select, Select] = useState(false)
    const [show, Show] = useState({i:0, n:0})
    const [tilaawa, Tilaawa] = useState(null)
    const [items, Items]= useState([])
    const audio = document?.getElementById("tilaawa")
    const [focus, Focus] = useState(0)

    const splitter = new meSplitter("Side", "PartContainer")

    useLayoutEffect (()=>{  // like useEffect but synchronously after all DOM
  
        splitter.selectorAll()

        if(section.Id>0) {
            onNode(section.Id)
        }
        //Etat(`splitter ${splitter.items.length}`)

        Message('بِسۡمِ ٱللهِ ٱلرَّحۡمَـٰنِ ٱلرَّحِيمِ')
    },[])

    //const shuffle = (arr) => arr.sort(() => Math.random() - 0.5);

    useEffect(() => {
        //alert(`load ${loaded} connect ${props.connected}`)
        if(loaded) {
            if(section.Items.length>0) {
                section.Items.forEach(item => {
                    //alert(JSON.stringify(item))
                    //if(!item?.Iqrae?.endsWith(".mp3"))
                    {
                        if(section?.SooraId>0 && item?.Tilaawa>0 && item?.Duration>0)
                            item["Iqrae"] = `${section.SooraId.toString().padStart(3,'0')}/${item.Tilaawa.toString().padStart(5,'0')}${Sah2(item.Tilaawa,item.Duration)}.mp3`
                        else 
                            item["Iqrae"] = ""
                    }
                    //alert(item["Iqrae"])
                })
            }
        }
        else if(props.connected){
            Read(`moshaf/ViewSections/1`,Items,Load,null)
            Section({...section, Id: Cookie('meSection')??1, Hizb:1})
        }
    }, [loaded])

useEffect(() => {
    if(props.connected && section?.Id>0) {
        //alert(`getPart ${section.Id}`)
        Api.get(`moshaf/Part/${section.Id}`)
        .then(response => {
            //console.log('response',response.data); alert(response.data.Items.length)
            Section(response.data)
            Number(0)

            document.cookie = `meSection=${section.Id}`
        })
        .catch(err => console.error(err))
    }
}, [section.Id])

  
const onNext = (e, step=1) => {
    //alert(`onNext ${items.length} ${step}`)
    Select(false)
    items.forEach((item, index)=>{
        if(item.Id===section.Id) {
            let next = step>0 ? ((index+1<items.length) ? index+step : 0) : ((index-1>=0) ? index+step : items.length-1)
            onNode(items[next].Id)
            return
        }
    })   
}

const onNode = (id) => {
    //alert(`onNode ${id}`)
    Section({...section, Id: id})
}

const Sah2 = (sah1, duration) => { 
    let hmmss = sah1.toString().padStart(5, '0')

    let secs = hmmss.substring(0,1)*3600+hmmss.substring(1,3)*60+hmmss.substring(3,5)*1 + duration; 

    let h = Math.floor(secs / 3600); 
    let mm = Math.floor((secs % 3600) / 60); 
    let ss = secs % 60; 

    const sah2 = `${h}${mm.toString().padStart(2, '0')}${ss.toString().padStart(2, '0')}`; 
    return sah2
}

// To avoide for Dev MeR 
useEffect(() => {
    if(play) {
        const interval = setInterval(() => {  
            Now(new Date())

        }, 1000)
        return () => clearInterval(interval)
    }
}, [play]);


const onSelect = (e, index) => {
    if(number!==index) {
        Number(index)
        Select(true)
        e.preventDefault()
    }
    else {
        Select(!select)
    }
}

useEffect(()=>{
    if(number>=0 && number<section.Items?.length) {
        //alert(`number=${number} : ${JSON.stringify(section)}`)
        const item = section.Items[number]
        if(item?.Duration>0) {
            let url = `${path}${item.Iqrae}`; //alert(url)

            Show({i:0, n:item.Duration})
            Tilaawa(url)
        }
        else {
            Show({i:0, n:0})
            Tilaawa(null)
        }
    }
},[number])

useEffect(()=>{
    if(props.connected && audio?.src) {
        if(tilaawa && tilaawa.endsWith('.mp3')) {
            //audio.src = tilaawa
            //audio.playbackRate=speed
            //alert(tilaawa)
            if( ! (number===0 && section.Id===1)) {
                audio.play()
            }
        }
        else {
            audio.pause()
        }
    }
},[tilaawa, audio])

useEffect(() => {
    //Message(`Audio is play=${play}`);
    if(props.connected && audio?.src) {
        select ? audio.play() : audio.pause()
    }
}, [select]);


useEffect(()=>{

    if(number===section.Items.length) {
        //Load(false)
        //Show({i:0, n:0})
        onNext()
    }
    else if(select) {
        if(show.n>0 && show.n===show.i) {
            //Number(number + 1)
        }
        else {
            Show({...show, i:show.i+1})
        }
    }
    
    Focus(focus+1)

    Etat(`Show ${number} (${show.i} / ${show.n} sec) ${toTime(focus)}`) 
    //console.log(show)
},[now])

const onScrollTop = () => {
    if(show.i>2) {
        //alert(show.i)
    }
}


const SavePdf = (name) => {
    const pdf = new jsPdf("p", "mm", "a5");
    const size = pdf.internal.pageSize;
    //const pw = parseInt(pdf.internal.pageSize.getWidth());
    //const ph = parseInt(pdf.internal.pageSize.getHeight());

    //alert(`${JSON.stringify(size)}`)
    const element=document.querySelector('#SentenceDiv')
    
    html2canvas(element, { 
      useCORS: true,
      allowTaint: false,   // Set to false to avoid security errors
        scale: 2.1             // Improves image quality
    })
    .then((canvas)=>{
      const data = canvas.toDataURL('image/jpeg'); //console.log('ToData', data); alert(data.length)
      //pdf.addImage(data, 'JPEG',-0.5,-0.5, size.width+1, size.height+1); // 
      pdf.addImage(data, 'JPEG', 0, 0, size.width+0.2, size.height+0.2);  // en mm
      pdf.save(`Moshaf-${name}.pdf`)
    })
    .catch((error) => {
      Message(error)
    })
  }
  
const handleError = () => { 
    Message('Audio file cannot be loaded. Please check the source path.'); 
}; 


// MeR 260122
const setFont = (element, delta) => {
    //alert(`${element.id} delta=${delta} ${JSON.stringify(element.style)}`)
    let size = parseFloat(element.style.fontSize)+delta
    element.style.fontSize = `${size}rem`;
    //alert(element.style.fontSize)
}

const onFont = (e) => {
    
    if(e.target.id==='SentenceDiv') {
        const item = document.getElementById("Options");
        if(!item.style.fontSize.endsWith('rem'))
            item.style.fontSize = `${1.6}rem`;

        //alert(`${e.clientY}`)
        if(e.clientY<300) {
            setFont(item, -0.1)
        }
        else if(e.clientY>600) {
            setFont(item, 0.1)
        }

        /*
        switch(e.key) {
            case "ArrowDown": 
                setFont(e.target, 0.1)
                break
            
            case "ArrowUp": 
                setFont(e.target, -0.1)
                break

            case "Enter": 
                e.preventDefault()
                break
            case "Escape": 
                e.preventDefault()
                break
        }
        */
    }
}
  

return (

props.connected ?
    <div className="Home" id="PartContainer" 
    onMouseDown={(e)=>{splitter.mouseDown(e)}} 
    onMouseMove={(e)=>{splitter.mouseMove(e)}} 
    onMouseUp={(e)=>{splitter.mouseUp(e)}}
    >

<Button onClick={e => {SavePdf(section.Id)}} className="SaveButton">Save</Button>

        <div className="side vside" id="SideSentence" style={props.layout ? {width:  '70%'} : {width:  '100%'}}>

            <div onScroll={onScrollTop} id="SentenceDiv" onClick={(e) => onFont(e)}>
            { loaded && section?.Items &&

                <>
                                <Logo src={base.logo} alt={base.domain} title={base.name} />

                    <Question dangerouslySetInnerHTML={{ __html: `${section.Soora} (${section.Id}) - ${section.Aaya} ثمن${section.Tomon}/${section.Hizb}`}}>  
                    </Question>                    
                    
<Options id='Options'>

<table>
<tbody>

                        {section?.Items.map((item, index) => (
                            <tr key={`jomla-${index}`} >

        <td id={`jomla-${index}`} onClick={e => onSelect(e, index)}>
            <div className='Option' title={`الآية ${item.Aaya} (${item.Number})`} 
                style={{color:`rgba(${item.Font})`, 
                    fontWeight:(play && number===index)?'bold':'normal', 
                    backgroundColor:`rgba(${item.Back})`, borderColor:`rgba(${item.Bord})`}} >
                {item.Content}
                <div className='Progressing'
                    style={ (number===index)?{width:`${(show.i+1)*100/show.n}%`}:{width:0}}>
                </div>
            </div>
        </td>
                            </tr>
                        ))}

</tbody>
</table>

</Options>

        <Info>{base.domain}</Info>


    <div id="save-button" data-html2canvas-ignore="true">
    <Button className="mr-2 NavButton" variant="warning" 
            style={{ left:0 }}
            onClick={e=>onNext(e,1)}
            ><i className="fa fa-arrow-left" title='مقطع جديد'></i>
        </Button>

        <Button className="mr-2 NavButton" variant="warning" 
            style={{ right:0 }}
            onClick={e=> onNext(e,-1)}
            ><i className="fa fa-arrow-right" title='مقطع جديد'></i>
        </Button>
    </div>
                </>

            }

        </div>

            <audio controls
                id="tilaawa" src={tilaawa} 
                onPlay={()=>{Play(true)}} 
                onPause={()=>{Play(false)}} 
                onEnded={()=>{Number(number+1)}}
                onError={handleError}                 
                autobuffer="autobuffer" 
                style={{height:'1rem', margin:'2rem 1rem'}} />


    </div>

    <div className="side vside" id="SideSection" style={props.layout ? {width:  '30%'} : {width: 0}}>
        <TreeView onChange={onNode} Id='9' selected={section.Id} layout={props.layout} />
    </div>


<ToNotify 
    message={message}
    onClose={()=>{Message('')}}
/>
</div>
: 
    <DefaultControl />

    )
}

export default Sentences

const Logo = styled.img`
  float: right;
  top:0;
  height: 5rem;
  border-radius: 10%;
`;

const Info = styled.div`
    position:absolute;
    top: 200mm;
    font-size: .9rem;
    color: silver;
`;

const Options = styled.div`
    display: flex;
    direction : rtl;
    flex-direction: column;
`;

const Question = styled.div`
    width: 100%;
    font-size: 1.8rem;
    margin: 1rem auto;
    /*color: rgb(1,1,1);*/
    color : white;
`;

